import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import rte, { command } from '../rte.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import selectInput from './selectInput/selectInput.js'
import closest from "@mailobj-browser/front/js/selectors/closest.js"
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    select
  ) => {
    const { value } = select
    const form = closest('form', select)
    const rte = one('iframe[data-rte]', form)

    if (rte && rte.id) {
      command(rte.id, 'formatBlock', value)
    }
  }
})

export const highlight = (
  select,
  modifier,
  text = null
) => {
  if (!text) {
    return
  }
  
  const { ownerDocument } = text
  const { body } = ownerDocument
  const template = one('template', select)
  const { content } = template
  const inputs = all('input', content)
  let current = text

  while (true) {
    const { parentNode } = current

    if (!parentNode || parentNode === body) {
      break
    }

    const { nodeName } = parentNode
    const tag = `<${nodeName.toLowerCase()}>`

    for (const input of inputs) {
      const { value } = input

      if (value === tag) {
        selectInput(select, template, input)
        select.classList.add(modifier)

        return
      }
    }

    current = parentNode
  }

  selectInput(select, template, inputs.at(0))
}

export default select => {
  onInput.listen(select)
  rte(select, object(null, { highlight }))
}
